import { COLORS, pickThemeColor, pickThemeFontSize, pickThemeFontStyles } from '@/theme';
import styled from 'styled-components';

export const StyledCard = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  cursor: default;
  align-items: center;
  padding: 1rem;
  background-color: ${pickThemeColor('BG_SECONDARY')};
  border: 1px solid ${pickThemeColor('LIGHT_PURPLE')};
  width: 100%;
  border-radius: 0.25rem;
`;

export const StyledButton = styled.button<{
  $color?: keyof typeof COLORS;
}>`
  background-color: transparent;
  border: none;
  box-shadow: none;
  cursor: pointer;

  .anticon {
    font-size: ${pickThemeFontSize('24')};
    color: ${({ $color = 'GREY' }) => pickThemeColor($color)};

    svg {
      fill: none;
    }
  }
`;

export const StyledAction = styled.div`
  display: flex;
  gap: 0.5rem;
`;

export const StyledName = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
  text-align: start;
  ${pickThemeFontStyles('16', '26')}

  .anticon {
    font-size: ${pickThemeFontSize('32')};
  }
`;
